(() => {
  const controllerKey = Symbol.for('soulcrystal.sparkNativePurchase.controller');
  document[controllerKey]?.destroy();

  const cleanups = [];

  const initialize = (purchase) => {
    const scope = purchase.closest('[data-spark-purchase-page]') ?? purchase;
    const variantSelect = purchase.querySelector('[data-spark-native-variant]');
    const variantInput = purchase.querySelector('[data-spark-native-variant-id]');
    if (!(variantSelect instanceof HTMLSelectElement) || !(variantInput instanceof HTMLInputElement)) return;

    const purchaseEnabled = purchase.dataset.purchaseEnabled === 'true';
    const quantityInput = purchase.querySelector('input[name="quantity"]');
    const quantityButtons = [...purchase.querySelectorAll('quantity-selector-component button')];
    const submitButtons = [...scope.querySelectorAll('[data-spark-native-submit], .spark-native-add')];
    const payment = purchase.querySelector('[data-spark-native-payment]');
    const note = purchase.querySelector('[data-spark-native-note]');

    const synchronize = () => {
      const option = variantSelect.selectedOptions[0];
      if (!option) return;

      const available = option.dataset.available === 'true';
      const canPurchase = purchaseEnabled && available;
      variantInput.value = option.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));

      scope.querySelectorAll('[data-spark-native-price]').forEach((price) => {
        price.textContent = option.dataset.price ?? price.textContent;
      });
      scope.querySelectorAll('[data-spark-native-variant-name]').forEach((name) => {
        name.textContent = option.textContent.replace(/\s+—\s+[^—]+(?:\s+—\s+Sold out)?$/, '').trim();
      });

      if (quantityInput instanceof HTMLInputElement) {
        const minimum = Number(option.dataset.min) || 1;
        const increment = Number(option.dataset.step) || 1;
        const maximum = Number(option.dataset.max) || null;
        quantityInput.min = String(minimum);
        quantityInput.step = String(increment);
        if (maximum) quantityInput.max = String(maximum);
        else quantityInput.removeAttribute('max');
        quantityInput.value = String(Math.max(minimum, Math.min(maximum ?? Infinity, Number(quantityInput.value) || minimum)));
        quantityInput.disabled = !canPurchase;
      }

      quantityButtons.forEach((button) => { button.disabled = !canPurchase; });
      submitButtons.forEach((button) => {
        button.disabled = !canPurchase;
        button.setAttribute('aria-disabled', String(!canPurchase));
      });
      if (payment instanceof HTMLElement) payment.hidden = !canPurchase;
      if (note instanceof HTMLElement && purchaseEnabled) {
        note.textContent = canPurchase ? 'Checkout methods are rendered and controlled by Shopify.' : 'This variant is currently unavailable.';
      }
    };

    variantSelect.addEventListener('change', synchronize);
    cleanups.push(() => variantSelect.removeEventListener('change', synchronize));
    synchronize();
  };

  document.querySelectorAll('[data-spark-native-purchase]').forEach(initialize);
  document[controllerKey] = {
    destroy() {
      cleanups.splice(0).forEach((cleanup) => cleanup());
      delete document[controllerKey];
    },
  };
})();
